import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ugcVideoShape, catalogBibShape, userIdentityShape, shelfItemShape } from '@bibliocommons/bc-prop-types';
import { selectUserEntities } from 'app/selectors/EntitiesSelector';
import { selectShelvesForCurrentUser } from 'app/selectors/ShelfSelector';
import ModalActions from 'app/actions/ModalActions';

import VideoDisplay from './VideoDisplay';

export class VideoDisplayContainer extends React.PureComponent {
  render() {
    return <VideoDisplay {...this.props} />;
  }
}

VideoDisplayContainer.propTypes = {
  // ownProps
  video: ugcVideoShape.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleDeleteSuccess: PropTypes.func,
  displayStaffBadge: PropTypes.bool,

  // Redux props
  users: ImmutablePropTypes.mapOf(userIdentityShape).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfItem: shelfItemShape
};

const mapStateToProps = (state, ownProps) => ({
  users: selectUserEntities(state),
  shelfItem: selectShelvesForCurrentUser(state).get(ownProps.catalogBib.get('metadataId'))
});

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(VideoDisplayContainer);
